import { ReactNode } from "react";

import { cn } from "../../ClassName";

interface Props {
  className?: string;
  children?: ReactNode;
  id?: string;
}

export function P1(props: Props) {
  const defaultStyling = {
    "tw-font-sans": true,
    "tw-text-[16px]": !props.className?.includes("tw-text-["),
    "tw-text-gray-0": !props.className?.includes("tw-text-"),
  };

  return (
    <p className={cn(defaultStyling, props.className)} id={props.id}>
      {props.children}
    </p>
  );
}
